module.exports = __webpack_public_path__ + "static/how-the-covid-19-pandemic-is-accelerating-change-390d025f6e7879a15885232183f7ee74.png";